import React from 'react';
import PropTypes from 'prop-types';

import { Input, useMaskedInput } from '../../Boneyard';

export const propTypes = {
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  mask: PropTypes.array.isRequired,
  placeholder: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  hasError: PropTypes.bool,
  automationHook: PropTypes.string,
  label: PropTypes.string,
  isRequired: PropTypes.bool,
  ariaDescribedBy: PropTypes.string,
  type: PropTypes.string,
  uppercase: PropTypes.bool,
};

export const defaultProps = {
  onBlur: Function.prototype,
  onChange: Function.prototype,
  hasError: false,
  isRequired: false,
  automationHook: '',
  placeholder: '',
  type: 'tel',
};

const MaskedInput = ({
  name,
  mask,
  value,
  placeholder,
  hasError,
  onChange,
  onBlur,
  automationHook,
  label,
  isRequired,
  ariaDescribedBy,
  uppercase,
  type,
  ...props
}) => {
  const input = React.useRef(null);
  const delimiter = mask.find(v => typeof v === 'string');
  React.useEffect(() => {
    let inputValue = input.current.value;
    // as we change the value of the input, the formik library keep sending us
    // the value back. and if it matches the mask, it will concatenate the delimiter permanently
    // thus, the user won't be able to delete the delimiter
    if (inputValue.substr(inputValue.length - 1) === delimiter) {
      inputValue = inputValue.slice(0, -1);
    }
    input.current.value = inputValue;
  });

  const removeDelimitersAndFormat = value => {
    value = uppercase ? value.toUpperCase() : value;
    // Remove characters which are not digits
    return type === 'tel'
      ? value.replace(/[^0-9]/g, '') || ''
      : value.replace(/[^0-9a-zA-Z]/g, '') || '';
  };

  const onValueChange = useMaskedInput({
    guide: false,
    input,
    mask,
    initialValue: value,
    onChange: val => onChange(removeDelimitersAndFormat(val)),
  });

  let currentValue = input.current?.value || value;
  currentValue = uppercase ? currentValue.toUpperCase() : currentValue;

  return (
    <Input
      value={currentValue}
      type={type}
      label={label}
      isRequired={isRequired}
      inputRef={input}
      name={name}
      placeholder={placeholder}
      hasError={hasError}
      onChange={onValueChange}
      onBlur={onBlur}
      maxLength={mask.length}
      automationHook={automationHook}
      ariaDescribedBy={ariaDescribedBy}
      {...props}
    />
  );
};

MaskedInput.propTypes = propTypes;
MaskedInput.defaultProps = defaultProps;

export default MaskedInput;
